module.exports = __webpack_public_path__ + "media/images/index/product_line/motorcycle-4faceeb3fee4b238bbbaad53d465a438.svg";